<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 480 480"
    shape-rendering="geometricPrecision"
    text-rendering="geometricPrecision"
  >
    <g
      id="exjknWvygDo2_tr"
      transform="translate(239.938141,240.768888) rotate(1710)"
    >
      <g
        id="exjknWvygDo2"
        transform="scale(0.8,0.8) translate(-243.365402,-223.058626)"
        opacity="0"
      >
        <path
          d="M217.503,354.844c0-1.394-.935-2.589-2.779-2.908-26.06-4.524-49.686-18.101-66.715-38.339-17.03-20.238-26.37-45.837-26.374-72.286c0-50.427,27.407-89.188,84.789-122.976c31.704-18.6684,55.375-37.385,55.375-64.636c0-39.3515-43.161-62.28013-99.929-50.68735C88.3082,18.0338,14,87.4458,14,184.258c0,117.926,85.4101,177.184,164.64,177.184c15.141,0,22.361-.25,32.37-2.396c4.545-.974,6.493-1.934,6.493-4.202ZM86.093,376.929c-15.5691,0-23.281,7.359-23.281,18.556c0,23.279,32.8788,54.726,75.923,54.726c17.864,0,32.206-6.485,32.206-20.202c0-24.034-57.85-53.08-84.848-53.08ZM360.029,100.544c-51.12,0-95.971,16.357-105.232,21.659-5.013,2.869-5.778,3.915-5.778,5.391c0,1.559.998,2.603,2.774,2.882c26.328,4.259,50.28,17.751,67.567,38.059c17.288,20.308,26.783,46.106,26.784,72.776c0,36.528-16.145,66.775-39.568,90.199-28.21,28.209-62.096,39.601-82.449,57.807-21.186,18.955-21.221,46.057-9.145,63.777C226.131,469.452,248.659,480,280.263,480c81.001,0,138.23-66.047,138.23-147.087c0-44.028-18.297-84.258-41.321-117.115-3.298-4.706-1.586-8.466,2.662-8.466c12.85,0,23.919,24.645,50.107,24.645c25.244,0,44.712-18.928,44.712-49.172c0-41.151-39.945-82.261-114.624-82.261Z"
          transform="matrix(0 1-1 0 484.3265-9.940551)"
          fill="#a414f7"
        />
      </g>
    </g>
    <g
      id="exjknWvygDo4_tr"
      transform="translate(237.670196,240) rotate(1620)"
    >
      <g
        id="exjknWvygDo4"
        transform="scale(0.8,0.8) translate(-220.626715,-242.532746)"
      >
        <g transform="matrix(.662089 0 0 0.662089 116.207771 47.096754)">
          <path
            id="exjknWvygDo6"
            d="M-51.45265,0c0-21.704664,16.770356-51.168835,52.510687-51.168838C36.000473,-51.261242,51.45265,-24.158877,51.45265,0C51.45265,28.497846,28.416514,51.599915,0,51.599915s-51.45265-23.102069-51.45265-51.599915Z"
            transform="translate(268.472746 137.613215)"
            fill="#a414f7"
            stroke-width="0"
          />
        </g>
        <g
          id="exjknWvygDo7_to"
          transform="translate(343.998901,282.424619)"
        >
          <g
            transform="scale(0.455851,0.455851) translate(-308.261008,-120.131952)"
          >
            <path
              d="M-51.45265,0c0-28.497846,23.036136-51.599915,51.45265-51.599915s51.45265,23.102069,51.45265,51.599915-23.036136,51.599915-51.45265,51.599915-51.45265-23.102069-51.45265-51.599915Z"
              transform="translate(336.48157 85.280009)"
              fill="#a414f7"
              stroke-width="0"
            />
          </g>
        </g>
        <g
          id="exjknWvygDo9_to"
          transform="translate(169.992483,243.031275)"
        >
          <g
            transform="scale(0.263374,0.251667) translate(-343.900528,-139.376205)"
          >
            <path
              d="M-51.45265,0c0-28.497846,23.036136-51.599915,51.45265-51.599915s51.45265,23.102069,51.45265,51.599915-23.036136,51.599915-51.45265,51.599915-51.45265-23.102069-51.45265-51.599915Z"
              transform="translate(379.10782 267.093872)"
              fill="#a414f7"
              stroke-width="0"
            />
          </g>
        </g>
        <g transform="matrix(1.020815 0 0 1.020817-93.74814 221.533255)">
          <path
            id="exjknWvygDo12"
            d="M-51.45265,0c0-28.497846,23.036136-51.599915,51.45265-51.599915s51.45265,23.102069,51.45265,51.599915c.000001-11.67947-3.869294-24.265249-12.823285-36.538457C69.431047,5.681312,40.062652,51.599915,0,51.599915c-6.542403,0-12.799609-1.224571-18.556147-3.457626C-37.80277,40.67621,-51.45265,21.936717,-51.45265,0Z"
            transform="translate(343.900521 139.376207)"
            fill="#a414f7"
            stroke-width="0"
          />
        </g>
        <g transform="matrix(.600874 0 0 0.600875-90.422113 216.486266)">
          <path
            id="exjknWvygDo14"
            d="M-51.45265,0c0-28.497846,23.036136-51.599915,51.45265-51.599915s51.45265,23.102069,51.45265,51.599915-23.036136,51.599915-51.45265,51.599915-51.45265-23.102069-51.45265-51.599915Z"
            transform="translate(343.14884 140.374845)"
            fill="#a414f7"
            stroke-width="0"
          />
        </g>
        <path
          id="exjknWvygDo15"
          d="M-51.45265,0c0-28.497846,23.036136-51.599915,51.45265-51.599915s51.45265,23.102069,51.45265,51.599915-23.036136,51.599915-51.45265,51.599915-51.45265-23.102069-51.45265-51.599915Z"
          transform="translate(141.762561 155.149231)"
          fill="#a414f7"
          stroke-width="0"
        />
      </g>
    </g>
  </svg>
</template>

<style>
#exjknWvygDo2_tr {
  animation: exjknWvygDo2_tr__tr 4500ms linear infinite normal forwards;
}
@keyframes exjknWvygDo2_tr__tr {
  0% {
    transform: translate(239.938141px, 240.768888px) rotate(1710deg);
    animation-timing-function: cubic-bezier(0.42, 0, 1, 1);
  }
  33.333333% {
    transform: translate(239.938141px, 240.768888px) rotate(1350deg);
    animation-timing-function: cubic-bezier(0, 0, 0.58, 1);
  }
  51.111111% {
    transform: translate(239.938141px, 240.768888px) rotate(1158deg);
    animation-timing-function: cubic-bezier(0.42, 0, 1, 1);
  }
  66.666667% {
    transform: translate(239.938141px, 240.768888px) rotate(1350deg);
    animation-timing-function: cubic-bezier(0, 0, 0.58, 1);
  }
  100% {
    transform: translate(239.938141px, 240.768888px) rotate(1710deg);
  }
}
#exjknWvygDo2 {
  animation: exjknWvygDo2_c_o 4500ms linear infinite normal forwards;
}
@keyframes exjknWvygDo2_c_o {
  0% {
    opacity: 0;
  }
  31.111111% {
    opacity: 0;
  }
  33.333333% {
    opacity: 1;
  }
  66.666667% {
    opacity: 1;
  }
  68.888889% {
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}
#exjknWvygDo4_tr {
  animation: exjknWvygDo4_tr__tr 4500ms linear infinite normal forwards;
}
@keyframes exjknWvygDo4_tr__tr {
  0% {
    transform: translate(237.670196px, 240px) rotate(1620deg);
    animation-timing-function: cubic-bezier(0.42, 0, 1, 1);
  }
  33.333333% {
    transform: translate(237.670196px, 240px) rotate(1260deg);
    animation-timing-function: cubic-bezier(0, 0, 0.58, 1);
  }
  51.111111% {
    transform: translate(237.670196px, 240px) rotate(1068deg);
    animation-timing-function: cubic-bezier(0.42, 0, 1, 1);
  }
  66.666667% {
    transform: translate(237.670196px, 240px) rotate(1260deg);
    animation-timing-function: cubic-bezier(0, 0, 0.58, 1);
  }
  100% {
    transform: translate(237.670196px, 240px) rotate(1620deg);
  }
}
#exjknWvygDo4 {
  animation: exjknWvygDo4_c_o 4500ms linear infinite normal forwards;
}
@keyframes exjknWvygDo4_c_o {
  0% {
    opacity: 1;
  }
  33.333333% {
    opacity: 1;
  }
  35.555556% {
    opacity: 0;
  }
  64.444444% {
    opacity: 0;
  }
  66.666667% {
    opacity: 1;
  }
  100% {
    opacity: 1;
  }
}
#exjknWvygDo6 {
  animation: exjknWvygDo6__m 4500ms linear infinite normal forwards;
}
@keyframes exjknWvygDo6__m {
  0% {
    d: path(
      "M-51.45265,0C-51.45265,-21.704664,-34.682294,-51.168835,1.058037,-51.168838C36.000473,-51.261242,51.45265,-24.158877,51.45265,0C51.45265,28.497846,28.416514,51.599915,0,51.599915C-28.416514,51.599915,-51.45265,28.497846,-51.45265,0Z"
    );
  }
  13.333333% {
    d: path(
      "M-51.45265,0C-51.45265,-21.704664,-34.682294,-51.168835,1.058037,-51.168838C36.000473,-51.261242,51.45265,-24.158877,51.45265,0C51.45265,28.497846,28.416514,51.599915,0,51.599915C-28.416514,51.599915,-51.45265,28.497846,-51.45265,0Z"
    );
  }
  33.333333% {
    d: path(
      "M-19.998906,-127.840946C-22.963403,-149.862597,33.900133,-141.388098,80.105708,-123.689927C109.768471,-112.328168,135.038766,-97.165055,137.267638,-83.828793C142.968415,-49.718685,97.806255,-47.376168,57.46286,-67.005205C17.119465,-86.634242,-18.574059,-108.603866,-19.998906,-127.840946Z"
    );
  }
  66.666667% {
    d: path(
      "M-16.758993,-142.656762C-12.74664,-160.43716,38.169348,-165.689412,79.216266,-149.697193C116.370843,-135.221462,142.147448,-108.257708,142.390278,-77.692202C142.500272,-63.847039,128.323455,-35.175942,49.766686,-64.978311C-28.790083,-94.78068,-19.523368,-134.148881,-16.758993,-142.656762Z"
    );
  }
  82.222222% {
    d: path(
      "M-51.45265,0C-51.45265,-21.704664,-34.682294,-51.168835,1.058037,-51.168838C36.000473,-51.261242,51.45265,-24.158877,51.45265,0C51.45265,28.497846,28.416514,51.599915,0,51.599915C-28.416514,51.599915,-51.45265,28.497846,-51.45265,0Z"
    );
  }
  100% {
    d: path(
      "M-51.45265,0C-51.45265,-21.704664,-34.682294,-51.168835,1.058037,-51.168838C36.000473,-51.261242,51.45265,-24.158877,51.45265,0C51.45265,28.497846,28.416514,51.599915,0,51.599915C-28.416514,51.599915,-51.45265,28.497846,-51.45265,0Z"
    );
  }
}
#exjknWvygDo7_to {
  animation: exjknWvygDo7_to__to 4500ms linear infinite normal forwards;
}
@keyframes exjknWvygDo7_to__to {
  0% {
    transform: translate(343.998901px, 282.424619px);
  }
  6.666667% {
    transform: translate(343.998901px, 282.424619px);
  }
  33.333333% {
    transform: translate(119.995584px, 128.716534px);
  }
  62.222222% {
    transform: translate(330.706025px, 346.992225px);
  }
  93.333333% {
    transform: translate(343.998901px, 282.424619px);
  }
  100% {
    transform: translate(343.998901px, 282.424619px);
  }
}
#exjknWvygDo9_to {
  animation: exjknWvygDo9_to__to 4500ms linear infinite normal forwards;
}
@keyframes exjknWvygDo9_to__to {
  0% {
    transform: translate(169.992483px, 243.031275px);
  }
  35.555556% {
    transform: translate(339.131863px, 258.458075px);
  }
  60% {
    transform: translate(339.131863px, 258.458075px);
  }
  100% {
    transform: translate(169.992483px, 243.031275px);
  }
}
#exjknWvygDo12 {
  animation: exjknWvygDo12__m 4500ms linear infinite normal forwards;
}
@keyframes exjknWvygDo12__m {
  0% {
    d: path(
      "M-51.45265,0C-51.45265,-28.497846,-28.416514,-51.599915,0,-51.599915C28.416514,-51.599915,51.45265,-28.497846,51.45265,0C51.452651,-11.67947,47.583356,-24.265249,38.629365,-36.538457C69.431047,5.681312,40.062652,51.599915,0,51.599915C-6.542403,51.599915,-12.799609,50.375344,-18.556147,48.142289C-37.80277,40.67621,-51.45265,21.936717,-51.45265,0Z"
    );
  }
  8.888889% {
    d: path(
      "M-61.115656,14.886019C-60.646164,-18.566878,-20.50265,-36.650994,11.171303,-50.822528C42.845256,-64.994061,56.766562,-40.60611,56.766562,-40.60611C56.766562,-40.606111,56.766562,-40.606111,56.766562,-40.606111C56.766521,-40.606246,76.72543,25.277761,26.504938,55.956043C9.970163,63.290594,-9.457886,63.900436,-25.82428,58.957046C-46.852262,52.605647,-62.826123,37.087083,-61.115656,14.886019Z"
    );
  }
  33.333333% {
    d: path(
      "M-65.681245,56.13237C-62.010439,-0.175863,-10.455554,9.965734,44.273551,-46.191975C99.002656,-102.349684,63.326316,-222.802933,-22.452175,-233.3898C75.70588,-261.981731,162.191254,-192.598833,175.963057,-100.834504C183.545508,-50.311093,169.085856,6.996936,122.396379,58.473045C73.756879,110.465803,-3.721305,126.69159,-42.666131,106.218878C-60.20801,96.997374,-69.931999,80.330248,-65.681245,56.13237Z"
    );
  }
  66.666667% {
    d: path(
      "M-66.498785,62.884804C-59.190923,6.536166,16.654677,-4.269948,48.192835,-51.30163C108.418604,-153.360111,32.552438,-226.302744,-28.746699,-233.951867C65.527119,-259.972477,158.363857,-192.863909,173.095605,-109.98829C185.5072,-40.165033,157.227444,34.935356,130.225392,57.468516C114.452506,77.979694,-0.209777,151.998,-56.526873,91.672245C-63.705483,83.98266,-66.498785,62.884804,-66.498785,62.884804Z"
    );
  }
  88.888889% {
    d: path(
      "M-52.955512,23.817753C-49.296205,-15.420516,-19.887133,-24.208259,19.993816,-48.165222C59.874764,-72.122186,57.318523,-75.667166,57.318523,-75.667166C57.318523,-75.667166,62.06219,-70.60133,67.549474,-61.976049C82.169112,-38.995923,102.067219,9.250438,51.594849,54.274134C32.772691,68.691287,-0.751377,72.3357,-24.786706,63.284746C-41.937652,56.826235,-54.25707,43.903427,-52.955512,23.817753Z"
    );
  }
  100% {
    d: path(
      "M-51.45265,0C-51.45265,-28.497846,-28.416514,-51.599915,0,-51.599915C28.416514,-51.599915,51.45265,-28.497846,51.45265,0C51.452651,-11.67947,47.583356,-24.265249,38.629365,-36.538457C69.431047,5.681312,40.062652,51.599915,0,51.599915C-6.542403,51.599915,-12.799609,50.375344,-18.556147,48.142289C-37.80277,40.67621,-51.45265,21.936717,-51.45265,0Z"
    );
  }
}
#exjknWvygDo14 {
  animation: exjknWvygDo14__m 4500ms linear infinite normal forwards;
}
@keyframes exjknWvygDo14__m {
  0% {
    d: path(
      "M-51.45265,0C-51.45265,-28.497846,-28.416514,-51.599915,0,-51.599915C28.416514,-51.599915,51.45265,-28.497846,51.45265,0C51.45265,28.497846,28.416514,51.599915,0,51.599915C-28.416514,51.599915,-51.45265,28.497846,-51.45265,0Z"
    );
  }
  11.111111% {
    d: path(
      "M-51.45265,0C-51.45265,-28.497846,-28.416514,-51.599915,0,-51.599915C28.416514,-51.599915,51.45265,-28.497846,51.45265,0C51.45265,28.497846,28.416514,51.599915,0,51.599915C-28.416514,51.599915,-51.45265,28.497846,-51.45265,0Z"
    );
  }
  33.333333% {
    d: path(
      "M-226.838942,-34.459814C-171.698218,-139.016435,-58.437635,-42.055741,19.4565,21.114087C97.350635,84.283915,150.999682,75.104366,143.412275,91.108388C135.824868,107.11241,-10.248289,131.211105,-68.60621,131.057665C-126.964131,130.904225,-268.641095,61.422685,-226.838942,-34.459814Z"
    );
  }
  66.666667% {
    d: path(
      "M-213.0531,-60.460812C-156.907514,-132.5217,-60.254455,-27.526504,-24.280645,3.932931C11.693165,35.392366,143.858123,88.663585,143.858123,88.663585C143.637538,98.378234,-4.927042,150.316288,-101.519411,126.378214C-198.11178,102.44014,-277.950963,26.989808,-213.0531,-60.460812Z"
    );
  }
  100% {
    d: path(
      "M-51.45265,0C-51.45265,-28.497846,-28.416514,-51.599915,0,-51.599915C28.416514,-51.599915,51.45265,-28.497846,51.45265,0C51.45265,28.497846,28.416514,51.599915,0,51.599915C-28.416514,51.599915,-51.45265,28.497846,-51.45265,0Z"
    );
  }
}
#exjknWvygDo15 {
  animation: exjknWvygDo15__m 4500ms linear infinite normal forwards;
}
@keyframes exjknWvygDo15__m {
  0% {
    d: path(
      "M-51.45265,0C-51.45265,-28.497846,-28.416514,-51.599915,0,-51.599915C28.416514,-51.599915,51.45265,-28.497846,51.45265,0C51.45265,28.497846,28.416514,51.599915,0,51.599915C-28.416514,51.599915,-51.45265,28.497846,-51.45265,0Z"
    );
  }
  17.777778% {
    d: path(
      "M-44.581943,-52.72431C-33.234194,-82.172428,20.427311,-110.562402,44.869736,-97.309302C65.12612,-96.308957,101.51801,-45.238242,65.509097,-17.662617C33.239586,7.38847,-19.62687,66.823348,-8.109057,100.540776C-39.044637,93.507855,-86.462895,11.396552,-44.581943,-52.72431Z"
    );
  }
  31.111111% {
    d: path(
      "M-38.65909,-125.886148C15.337531,-156.514681,60.000536,-144.508824,76.110257,-132.469294C89.639513,-125.254839,122.109749,-78.464235,63.381286,-43.533649C-34.075908,12.280215,-74.126544,103.854768,7.655737,172.281806C-49.98956,165.286575,-187.199809,-24.635236,-38.65909,-125.886148Z"
    );
  }
  33.333333% {
    d: path(
      "M-37.671948,-138.079788C23.432818,-168.905057,66.596073,-150.166561,81.31701,-138.329293C93.725079,-130.079153,125.541705,-84.001901,63.026651,-47.845488C-45.295157,13.095506,-75.454363,109.534124,18.038663,183.746098C-44.058254,176.757148,-203.989295,-30.640534,-37.671948,-138.079788Z"
    );
  }
  66.666667% {
    d: path(
      "M-37.671948,-138.079788C23.432818,-168.905057,66.596073,-150.166561,81.31701,-138.329293C93.725079,-130.079153,125.541705,-84.001901,63.026651,-47.845488C-45.295157,13.095506,-75.454363,109.534124,18.038663,183.746098C-44.058254,176.757148,-203.989295,-30.640534,-37.671948,-138.079788Z"
    );
  }
  84.444444% {
    d: path(
      "M-51.45265,0C-51.45265,-28.497846,-28.416514,-51.599915,0,-51.599915C28.416514,-51.599915,51.45265,-28.497846,51.45265,0C51.45265,28.497846,28.416514,51.599915,0,51.599915C-28.416514,51.599915,-51.45265,28.497846,-51.45265,0Z"
    );
  }
  100% {
    d: path(
      "M-51.45265,0C-51.45265,-28.497846,-28.416514,-51.599915,0,-51.599915C28.416514,-51.599915,51.45265,-28.497846,51.45265,0C51.45265,28.497846,28.416514,51.599915,0,51.599915C-28.416514,51.599915,-51.45265,28.497846,-51.45265,0Z"
    );
  }
}
</style>
